<template>
  <BModal
    id="modal-delete-credential"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    content-class="w-160 h-26 mx-auto"
    body-class="px-2 pb-1 pt-0"
  >

    <div class="text-center py-2">
      <!-- Icon -->
      <div class="mb-3 mt-0 d-flex justify-content-center">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Delete"
          style="width: 100px;"
        >
      </div>

      <p class="h3 font-weight-bold text-black text-nowrap mb-2">
        Apakah Kamu yakin menghapus data ini?
      </p>

      <div
        class="d-flex"
        style="gap: 10px;"
      >
        <BButton
          variant="link"
          class="button-orange w-50"
          @click="handleCancle"
        >
          Batal
        </BButton>
        <BButton
          variant="link"
          class="button-all w-50"
          :disabled="loading"
          @click="handleDelete"
        >
          <BSpinner
            v-if="loading"
            small
          />
          <span v-else>Ya, Hapus</span>
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { credentialAxios } from './config'

export default {
  name: 'DeleteCredential',

  emits: ['deleted', 'delete-error', 'pin-session-expired'],

  data() {
    return {
      loading: false,
      selectedItem: null,
    }
  },

  methods: {
    async handleDelete() {
      this.loading = true
      try {
        await credentialAxios.delete(`v1/credential_management/secure/${this.selectedItem.id}`)

        this.$emit('deleted', this.selectedItem)
        this.hide()
        this.reset()
      } catch (err) {
        if (err.response?.status === 403) {
          this.hide()
          this.$emit('pin-session-expired', {
            onValid: () => this.handleDelete(),
          })
          return
        }
        this.$emit('delete-error', err)
      } finally {
        this.loading = false
      }
    },

    reset() {
      this.selectedItem = null
      this.loading = false
    },

    handleCancle() {
      this.hide()
    },

    show(item) {
      this.selectedItem = item
      this.loading = false
      this.$bvModal.show('modal-delete-credential')
    },

    hide() {
      this.$bvModal.hide('modal-delete-credential')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CredentialManagement.scss';
</style>
